import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import store, { persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfigProvider } from "antd";
import StyledThemeProvider from "./components/StyledThemeProvider";
// import { makeServer } from "./server";
import { NotificationProvider } from "./components/Notification";
import { App as ContextApp } from "antd";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import { lightThemeConfig } from "./themes/lightTheme";
import { darkThemeConfig } from "./themes/darkTheme";
import "./styles/darkMode.css";
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      cacheTime: 1000 * 60 * 60 * 1, // 24 hours
      refetchOnWindowFocus: false, // default: true
      refetchOnMount: false, // default: true
      // notifyOnChangeProps: [
      //   "isFetching",
      //   "isLoading",
      //   "isSuccess",
      //   "data",
      //   "error",
      // ],
      // staleTime: 60000,
      // refetchOnReconnect: false, // default: true
      // logger: {
      //   log: (...args) => {
      //     // Log debugging information
      //   },
      //   warn: (...args) => {
      //     // Log warning
      //   },
      //   error: (...args) => {
      //     // Log error
      //   },
      // },
    },
  },
});
// Dynamic Theme Provider Component
const DynamicThemeProvider = ({ children }) => {
  const { isDarkMode } = useTheme();
  const themeConfig = isDarkMode ? darkThemeConfig : lightThemeConfig;

  return (
    <ConfigProvider theme={themeConfig}>
      {children}
    </ConfigProvider>
  );
};

// xs	screen < 576px
// sm	screen ≥ 576px,
// md	screen ≥ 768px,
// lg	screen ≥ 992px,
// xl	screen ≥ 1200px,
// xxl	screen ≥ 1600px,

// if (
//   process.env.REACT_APP_MODE === "development" ||
//   process.env.REACT_APP_MODE === "staging"
// ) {
//   makeServer();
// }
ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <QueryClientProvider client={queryClient}>
        {/* {process.env.REACT_APP_MODE === "development" && (
          <ReactQueryDevtools initialIsOpen={false} position={"bottom-left"} />
        )} */}
        <ThemeProvider>
          <DynamicThemeProvider>
            <ContextApp
              notification={{
                placement: "top",
                duration: 3,
              }}
            >
              <StyledThemeProvider>
                <NotificationProvider>
                  <BrowserRouter basename={"/"}>
                    <App />
                  </BrowserRouter>
                </NotificationProvider>
              </StyledThemeProvider>
            </ContextApp>
          </DynamicThemeProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
);
// const Latest_Transactions_All = useQuery({
//   queryKey: [
//     "transactions",
//     {
//       page: 1,
//       page_size: 10,
//       apiType: "Latest_Transactions_All",
//     },
//   ],
//   queryFn: ({ signal }) => {
//     let params = {
//       config: {
//         signal: signal,
//       },
//       page: 1,
//       page_size: 10,
//       order_by: "-due_date",
//       is_reconciled: false,
//     };

//     const result = getTransactionByParams(params);
//     if (result) {
//       return result;
//     }
//   },
//   cacheTime: 60000,
//   backgroundFetch: true,
//   enabled: true,
//   priority: 3,
// });
